"use client";
import { Link } from "@/navigation";
import { LinkedinLogo, InstagramLogo, TiktokLogo, XLogo } from "@phosphor-icons/react";
import React from "react";
import { contactObj } from "@/lib/contacts";
import { useTranslations } from "next-intl";

// 判断是否为颜色值（hex / rgb），用于决定用 style 还是 className
const isColorValue = (v?: string) => v && (v.startsWith("#") || v.startsWith("rgb"));

const FollowUs = ({ className, textClass }: { className?: string; textClass?: string }) => {
	const t = useTranslations();
	return (
		<div className={`mt-6 flex ${className}`}>
			<p className="text-sm font-semibold">{t("base.followOn")}</p>
			<SocialList textClass={textClass}></SocialList>
		</div>
	);
};
export const SocialList = ({ className, textClass }: { className?: string; textClass?: string }) => {
	const t = useTranslations();
	// 颜色值（如 #606060）用 style；否则当 Tailwind 类名用（如 text-gray-500）
	const iconColorStyle = textClass && isColorValue(textClass) ? { color: textClass } : undefined;
	const iconClassName =
		textClass && !isColorValue(textClass)
			? textClass
			: iconColorStyle
				? ""
				: className || "text-white";
	const iconProps = {
		...(iconColorStyle && { style: iconColorStyle }),
		className: iconClassName || undefined,
	};
	return (
		<div className="right-content ml-10 flex items-center gap-5">
			<Link href={contactObj.Tiktok} target="_blank" aria-label={t("base.followTiktok")}>
				<TiktokLogo size={14} weight="fill" {...iconProps} />
			</Link>
			<Link href={contactObj.Linkedin} target="_blank" aria-label={t("base.followLinkedin")}>
				<LinkedinLogo size={14} weight="fill" {...iconProps} />
			</Link>
			<Link href={contactObj.Instagram} target="_blank" aria-label={t("base.followInstagram")}>
				<InstagramLogo {...iconProps}></InstagramLogo>
			</Link>
			<Link href={contactObj.Youtube} target="_blank" aria-label={t("base.followYoutube")}>
				<i className={`icon-youtube text-lg ${iconClassName}`} style={iconColorStyle}></i>
			</Link>
			<Link href={contactObj.Twitter} target="_blank" aria-label={t("base.followTwitter")}>
				<XLogo {...iconProps}></XLogo>
			</Link>
			<Link href={contactObj.Pinterest} target="_blank" aria-label={t("base.followPinterest")}>
				<i className={`icon-pinterest text-lg ${iconClassName}`} style={iconColorStyle}></i>
			</Link>
			<Link href={contactObj.FaceBook} target="_blank" aria-label={t("base.followFacebook")}>
				<i className={`icon-facebook text-lg ${iconClassName}`} style={iconColorStyle}></i>
			</Link>
		</div>
	);
};

export default FollowUs;
